<div class="container">

    <div class="box box-left">
        <div class="arrow-right"></div>
        <div class="box-container">
            <div class="font-color-grey">
                {{ 'D31' | translate: locale }}
            </div>
            <div class="font-weight-bold">
                <span *ngIf="review?.getMeasurementStartDate() && review?.getMeasurementEndDate()">
                    {{ review?.getMeasurementStartDate() | moment : review?.getMeasurementPeriod()! > 1 ? 'D MMM' : 'D'
                    : locale }} - {{ review?.getMeasurementEndDate() | moment : 'D MMM YYYY' : locale }}
                </span>
            </div>
            <div class="value">
                <span *ngIf="review?.getRevenueCount() !== null; else notAvailable">
                    {{ dashboard.getCurrencyCode() }} {{ review?.getRevenueCount() | formattedNumber : locale }}
                </span>
            </div>
            <div class="font-color-red" *ngIf="review?.getMeasurementStartDate() && review?.getMeasurementEndDate()">
                <a routerLink="/revenue" [queryParams]="qualifyingRevenueQueryParams" queryParamsHandling="merge">
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                    {{ 'D33' | translate: locale }}
                </a>
            </div>
        </div>
    </div>

    <div class="box box-right">
        <div class="box-container">
            <div class="font-color-grey">
                {{ 'D32' | translate: locale }}
            </div>
            <div class="font-weight-bold">
                <span *ngIf="review?.getDiscountStartDate() && review?.getDiscountEndDate()">
                    {{ review?.getDiscountStartDate() | moment : review?.getDiscountPeriod()! > 1 ? 'D MMM' : 'D' :
                    locale }} - {{ review?.getDiscountEndDate() | moment : 'D MMM YYYY' : locale }}
                </span>
            </div>
            <div class="value">
                <span *ngIf="review?.getDiscountPercent() !== null; else notAvailable">
                    {{ review?.getDiscountPercent() | formattedNumber : locale }}%
                </span>
            </div>
            <div class="font-color-red" *ngIf="review?.getDiscountStartDate() && review?.getDiscountEndDate()">
                <a routerLink="/shipment" [queryParams]="discountQueryParams" queryParamsHandling="merge">
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                    {{ 'D33' | translate: locale }}
                </a>
            </div>
        </div>
    </div>

</div>

<ng-template #notAvailable>{{ 'D10' | translate: locale }}</ng-template>
